import React from 'react';
export const About = () => {
  return <div className="bg-white" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-150">
        <div className="text-center" data-id="element-151">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-152">
            About Suretask
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-153">
            Your trusted appliance repair and maintenance partner across the UK.
          </p>
        </div>
        <div className="mt-12 lg:grid lg:grid-cols-2 lg:gap-8 items-center" data-id="element-154">
          <div data-id="element-155">
            <h2 className="text-2xl font-bold text-rose-900 mb-4" data-id="element-156">
              Our Mission
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-157">
              At Suretask, we specialise in fast, professional appliance repairs
              and service plans across the UK. From kitchens to living rooms,
              our trusted engineers are here to help with expert solutions for
              all your appliance needs.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-158">
              We understand that when an appliance breaks down, it can disrupt
              your entire household. That's why we've built our service around
              prompt responses, skilled technicians, and customer-focused
              solutions that get your home back to normal as quickly as
              possible.
            </p>
            <p className="text-gray-600" data-id="element-159">
              With our fixed-price support plans and UK-based service, we offer
              complete peace of mind for every home. No hidden costs, no
              complicated terms—just reliable repairs when you need them most.
            </p>
            <h2 className="text-2xl font-bold text-rose-900 mt-8 mb-4" data-id="element-160">
              Our Values
            </h2>
            <ul className="space-y-3 text-gray-600" data-id="element-161">
              <li className="flex items-start" data-id="element-162">
                <span className="text-rose-900 font-bold mr-2" data-id="element-163">•</span>
                <span data-id="element-164">
                  <strong data-id="element-165">Reliability:</strong> We show up when we say we will
                  and fix problems right the first time.
                </span>
              </li>
              <li className="flex items-start" data-id="element-166">
                <span className="text-rose-900 font-bold mr-2" data-id="element-167">•</span>
                <span data-id="element-168">
                  <strong data-id="element-169">Transparency:</strong> We're upfront about our pricing
                  and what our service plans cover.
                </span>
              </li>
              <li className="flex items-start" data-id="element-170">
                <span className="text-rose-900 font-bold mr-2" data-id="element-171">•</span>
                <span data-id="element-172">
                  <strong data-id="element-173">Expertise:</strong> Our engineers are highly trained
                  professionals who take pride in their work.
                </span>
              </li>
              <li className="flex items-start" data-id="element-174">
                <span className="text-rose-900 font-bold mr-2" data-id="element-175">•</span>
                <span data-id="element-176">
                  <strong data-id="element-177">Customer Focus:</strong> We listen to your needs and
                  tailor our service accordingly.
                </span>
              </li>
              <li className="flex items-start" data-id="element-178">
                <span className="text-rose-900 font-bold mr-2" data-id="element-179">•</span>
                <span data-id="element-180">
                  <strong data-id="element-181">Quality:</strong> We use genuine parts and follow
                  manufacturer guidelines for all repairs.
                </span>
              </li>
            </ul>
          </div>
          <div className="mt-10 lg:mt-0" data-id="element-182">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55Ti6aU2aaPz1k9bQx9m5s/11._Dishwasher_.png" alt="Person loading a dishwasher in modern kitchen" className="rounded-lg shadow-xl" data-id="element-183" />
          </div>
        </div>
        <div className="mt-16" data-id="element-184">
          <h2 className="text-2xl font-bold text-rose-900 mb-6 text-center" data-id="element-185">
            Why Choose Suretask?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186">
            <div className="bg-rose-50 p-6 rounded-lg" data-id="element-187">
              <h3 className="text-xl font-semibold text-rose-900 mb-3" data-id="element-188">
                Experienced Engineers
              </h3>
              <p className="text-gray-600" data-id="element-189">
                Our team consists of fully qualified, experienced technicians
                who undergo regular training to stay updated with the latest
                appliance technologies and repair techniques.
              </p>
            </div>
            <div className="bg-rose-50 p-6 rounded-lg" data-id="element-190">
              <h3 className="text-xl font-semibold text-rose-900 mb-3" data-id="element-191">
                Comprehensive Coverage
              </h3>
              <p className="text-gray-600" data-id="element-192">
                We cover a wide range of household appliances from all major
                brands, ensuring we can help no matter what appliance is causing
                you trouble.
              </p>
            </div>
            <div className="bg-rose-50 p-6 rounded-lg" data-id="element-193">
              <h3 className="text-xl font-semibold text-rose-900 mb-3" data-id="element-194">
                UK-Based Support
              </h3>
              <p className="text-gray-600" data-id="element-195">
                Our customer service team is based in the UK, providing
                friendly, helpful support whenever you need assistance with your
                appliances or service plan.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-196">
          <h2 className="text-2xl font-bold text-rose-900 mb-6 text-center" data-id="element-197">
            Our Commitment to You
          </h2>
          <p className="text-gray-600 text-center max-w-4xl mx-auto" data-id="element-198">
            At Suretask, we're committed to providing exceptional service that
            exceeds your expectations. We believe in building long-term
            relationships with our customers based on trust, reliability, and
            outstanding results. When you choose us, you're not just getting a
            repair service—you're gaining a dedicated partner who cares about
            keeping your home running smoothly.
          </p>
          <div className="mt-8 text-center" data-id="element-199">
            <a href="/contact" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800" data-id="element-200">
              Contact Us Today
            </a>
          </div>
        </div>
      </div>
    </div>;
};